import { FormControl, FormControlLabel, FormHelperText, Grid, InputLabel, LinearProgress, MenuItem, Switch } from '@material-ui/core'
import { ErrorMessage, Field, useFormikContext } from 'formik'
import { Select, TextField } from 'formik-material-ui'
import React, { memo, useEffect, useState } from 'react'
import { HuePicker } from 'react-color'

import { getAxiosInstance } from '../../../../../../../helpers/get_axios_instance'
import { lrsAdapter } from '../../../../../../../helpers/lrs_adapter'

// Esto deberia pasarse al Modelo
const fetchEtiquetas = async (cereal, cerealVariedad) =>
  lrsAdapter(
    await getAxiosInstance().get(`/consulta_etiqueta_color_silos?r={"clave":{"cereal":"${cereal}","cereal_variedad":"${cerealVariedad}"}}`)
  ).data

export const EtiquetasSelect = memo(() => {
  const [etiquetas, setEtiquetas] = useState([])
  const [isNewEtiqueta, setIsNewEtiqueta] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const {
    values,
    errors: { etiqueta: error },
    setFieldValue,
    handleChange
  } = useFormikContext()
  const { cereal, variedad } = values

  useEffect(() => {
    (async () => {
      if (!isNewEtiqueta) {
        if (cereal === undefined || variedad === undefined) {
          throw new Error('No puede utilizar el dropdown de etiqueta sin los dropdowns de cereal y variedad en el mismo formulario')
        }
        if (cereal && variedad) {
          try {
            setLoading(true)
            setEtiquetas(await fetchEtiquetas(cereal, variedad))
            setDisabled(false)
            setLoading(false)
          } catch (error) {
            setEtiquetas([])
            setDisabled(true)
            setLoading(false)
          }
        }
      } else {
        setEtiquetas([])
        setDisabled(true)
        setLoading(false)
      }
    })()
  }, [cereal, variedad, isNewEtiqueta])

  return (
    <Grid container spacing={2} direction='column' justify='space-between'>
      <>
        <Grid item>
          <FormControlLabel
            control={
              <Switch
                onChange={({ target: { checked } }) => {
                  setFieldValue('color', '')
                  setFieldValue('etiqueta', '')
                  setIsNewEtiqueta(checked)
                }}
              />
            }
            label='Nueva Etiqueta'
          />
        </Grid>
        {isNewEtiqueta || (
          <Grid item container spacing={2} justify='space-between'>
            <Grid item xs={12}>
              <FormControl style={{ width: '100%' }} variant='outlined' error={!!error}>
                <InputLabel id='etiqueta-label'>Etiqueta</InputLabel>
                <Field
                  component={Select}
                  name='etiqueta'
                  label='Etiqueta'
                  inputProps={{
                    labelId: 'etiqueta-label',
                    id: 'etiqueta'
                  }}
                  disabled={disabled}
                  onChange={(e) => {
                    const {
                      target: { value: etiqueta }
                    } = e
                    const selectedEtiquetaForColor = etiquetas.find(({ etiqueta: e }) => e === etiqueta)
                    setFieldValue('color', selectedEtiquetaForColor ? selectedEtiquetaForColor.color.trim() : '')

                    handleChange(e)
                  }}
                >
                  {etiquetas.map(({ etiqueta }) => (
                    <MenuItem key={etiqueta} value={etiqueta}>
                      {etiqueta}
                    </MenuItem>
                  ))}
                </Field>
                {loading && <LinearProgress />}
                <ErrorMessage name='variedad'>{(error) => <FormHelperText>{error}</FormHelperText>}</ErrorMessage>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              {(cereal && variedad) && <Field name='color'>
                {({ field: { value } }) => <HuePicker disabled color={value} />}
              </Field>}
            </Grid>
          </Grid>
        )}
        {isNewEtiqueta && (
          <>
            <Grid item>
              <Field component={TextField} label='Etiqueta' name='etiqueta' variant='outlined' />
            </Grid>
            <Grid item>
              <Field name='color'>
                {({ field: { value } }) => <HuePicker color={value} onChangeComplete={(color) => {
                  setFieldValue('color', color.hex)
                }} />}
              </Field>
            </Grid>
          </>
        )}
      </>
    </Grid>
  )
})
